import { render, staticRenderFns } from "./editBlog.vue?vue&type=template&id=3054cb36&scoped=true&"
import script from "./editBlog.vue?vue&type=script&lang=js&"
export * from "./editBlog.vue?vue&type=script&lang=js&"
import style0 from "./editBlog.vue?vue&type=style&index=0&id=3054cb36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3054cb36",
  null
  
)

export default component.exports